import type { CustomerHomeReadModel } from "../../read-models/home/customer-home-read-model";
import type { ReadSectionState } from "../../read-models/common/read-model";

export const HOME_SECTION_ORDER = [
  "needsYourAttention",
  "inProgress",
  "financialSummary",
  "relevantProductUsage",
  "recentActivity",
  "supportSummary",
  "commercialRecommendations",
] as const satisfies readonly (keyof CustomerHomeReadModel)[];

export type HomeSectionKey = (typeof HOME_SECTION_ORDER)[number];

export const shouldRenderHomeSection = (
  section: Readonly<{ state: ReadSectionState }>,
): boolean => section.state !== "EMPTY";

export const visibleHomeSectionOrder = (
  home: CustomerHomeReadModel,
): readonly HomeSectionKey[] =>
  HOME_SECTION_ORDER.filter((key) => shouldRenderHomeSection(home[key]));
